import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from 'jsx/elements/inputs/Checkbox';

const CreditRatingFilter = ({ onChange, filterValues, t }) => {
  return (
    <div className="form">
      <Checkbox
        name="veryLowRisk"
        id="veryLowRisk"
        value={filterValues.veryLowRisk}
        label={t('portfolio_filters_creditRating_veryLowRisk')}
        onChange={onChange}
      />
      <Checkbox
        name="lowRisk"
        id="lowRisk"
        value={filterValues.lowRisk}
        label={t('portfolio_filters_creditRating_lowRisk')}
        onChange={onChange}
      />
      <Checkbox
        name="possibleRisk"
        id="possibleRisk"
        value={filterValues.possibleRisk}
        label={t('portfolio_filters_creditRating_possibleRisk')}
        onChange={onChange}
      />
      <Checkbox
        name="highRisk"
        id="highRisk"
        value={filterValues.highRisk}
        label={t('portfolio_filters_creditRating_highRisk')}
        onChange={onChange}
      />
      <Checkbox
        name="cipNotCalculated"
        id="cipNotCalculated"
        value={filterValues.cipNotCalculated}
        label={t('portfolio_filters_creditRating_cipNotCalculated')}
        onChange={onChange}
      />
    </div>
  );
};

CreditRatingFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired
};

export default CreditRatingFilter;
